import { createOrientation, orientationCapacity } from "./types";

/**
 * @param {number} contW
 * @param {number} contH
 * @param {number} contL
 * @param {number} boxW
 * @param {number} boxH
 * @param {number} boxD
 * @returns {[number, number, number]}
 */
export function fitCounts(contW, contH, contL, boxW, boxH, boxD) {
  if (Math.min(boxW, boxH, boxD, contW, contH, contL) <= 0) {
    return [0, 0, 0];
  }
  return [
    Math.floor(contW / boxW),
    Math.floor(contH / boxH),
    Math.floor(contL / boxD),
  ];
}

/**
 * Try W/D swap only; keep carton height mapped to container height.
 * @param {number} cartonW
 * @param {number} cartonH
 * @param {number} cartonD
 * @param {number} contL
 * @param {number} contW
 * @param {number} contH
 */
export function chooseOrientation(cartonW, cartonH, cartonD, contL, contW, contH) {
  const candidates = [];

  for (const [boxW, boxD, label] of [
    [cartonW, cartonD, "W->width, D->length"],
    [cartonD, cartonW, "D->width, W->length"],
  ]) {
    const [nx, ny, nz] = fitCounts(contW, contH, contL, boxW, cartonH, boxD);
    candidates.push(
      createOrientation({
        boxW,
        boxH: cartonH,
        boxD,
        label,
        nx,
        ny,
        nz,
      })
    );
  }

  candidates.sort((a, b) => {
    const capDiff = orientationCapacity(b) - orientationCapacity(a);
    if (capDiff !== 0) return capDiff;
    if (b.nx !== a.nx) return b.nx - a.nx;
    return b.nz - a.nz;
  });

  return candidates[0];
}
